<fgb-banner [pageTitle]="'worksheet.gallery.title'"></fgb-banner>
<fgb-page-header [pageTitle]="'worksheet.gallery.title'" [backButtonLink]="'/'" [showBalance]="false" [showFooter]="false" />

<fgb-worksheet-list pageRequested="Gallery"></fgb-worksheet-list>
